import service from '@/api/healthData';

export const state = {
    loading: false,
    service: service,
    sums: {},
    pending: {}
};

export const getters = {
    loading: function (state) {
        return !!state.loading;
    },

    dailySum: (state) => (chartName, date) => {
        const key = `${chartName}|${date}`;

        return Object.prototype.hasOwnProperty.call(state.sums, key) ? state.sums[key] : null;
    }
};

export const mutations = {
    'SET_LOADING': function (state, boolean = true) {
        state.loading = boolean;
    },
    'SET_SUM': function (state, {key, value}) {
        state.sums = Object.assign({}, state.sums, {[key]: value});
    },
    'SET_PENDING': function (state, {key, promise = null}) {
        if (promise) {
            state.pending[key] = promise;
        } else {
            delete state.pending[key];
        }
    },
    'INVALIDATE': function (state, {chartName = null, date = null} = {}) {
        const sums = {};

        Object.keys(state.sums).forEach(key => {
            const [chart, day] = key.split('|');

            if ((chartName === null || chart === chartName) && (date === null || day === date)) {
                return;
            }

            sums[key] = state.sums[key];
        });

        state.sums = sums;
    },
    'CLEAR': function (state) {
        state.sums = {};
        state.pending = {};
    }
};

export const actions = {
    dailySum: function ({commit, state, rootGetters}, {chartName, date}) {
        const key = `${chartName}|${date}`;

        if (Object.prototype.hasOwnProperty.call(state.sums, key)) {
            return Promise.resolve(state.sums[key]);
        }

        if (state.pending[key]) {
            return state.pending[key];
        }

        const userId = rootGetters['auth/user']?.id;

        if (!userId) {
            return Promise.resolve(null);
        }

        const request = state.service.chart({
            TargetId: userId,
            ChartName: chartName,
            Interval: 'Day',
            Granularity: 'Day',
            ReferenceTs: date
        }).then((points) => {
            const sum = (points || []).reduce((carry, point) => carry + (Number(point.Value) || 0), 0);

            commit('SET_SUM', {key, value: sum});
            commit('SET_PENDING', {key});

            return sum;
        }).catch(() => {
            commit('SET_PENDING', {key});

            return null;
        });

        commit('SET_PENDING', {key, promise: request});

        return request;
    },

    storeDiaryEntry: function ({state, rootGetters}, {diaryName, values}) {
        const userId = rootGetters['auth/user']?.id;

        if (!userId) {
            return Promise.resolve(null);
        }

        const record = Object.assign({
            UserId: userId,
            SourceName: 'UserInput',
            MeasuredAt: new Date().toISOString()
        }, values);

        return state.service.storeDiary(diaryName, [record]).then((response) => {
            window.dispatchEvent(new CustomEvent('health-data-changed'));

            return response;
        });
    },

    invalidate: function ({commit}, payload = {}) {
        commit('INVALIDATE', payload);
    },

    clearModule: function ({commit}) {
        commit('CLEAR');
    }
};
